var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout-header",
    [
      _c("q-toolbar", { staticClass: "mobile-hide no-shadow" }, [
        _c(
          "div",
          { staticClass: "col-12 flex justify-end" },
          [
            _c("global-search"),
            _c("client"),
            _c("country"),
            _c(
              "div",
              [
                _vm.showControlPanel
                  ? _c("q-btn", {
                      attrs: {
                        flat: "",
                        label: _vm.$t("control_panel"),
                        icon: "fas fa-tachometer-alt"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({ name: "admin_overview" })
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c("notification"),
            _c("user-menu"),
            _c("language")
          ],
          1
        )
      ]),
      _c(
        "q-toolbar",
        { staticClass: "desktop-hide" },
        [
          _c("q-btn", {
            attrs: { flat: "", round: "", dense: "", icon: "fas fa-bars" },
            on: {
              click: function($event) {
                return _vm.openMenu()
              }
            }
          }),
          _c("q-toolbar-title", [
            _vm._v("\n\t\t\t" + _vm._s(_vm.$t(_vm.getTitle)) + " "),
            _vm.is_offline ? _c("span", [_vm._v(" - Offline")]) : _vm._e()
          ]),
          _c("notification")
        ],
        1
      ),
      _c("change-password", {
        attrs: { show_change_password: _vm.show_change_password },
        on: {
          hide_modal: function($event) {
            _vm.show_change_password = false
          }
        }
      }),
      _c("welcome-banner"),
      _c("mandatory-survey")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }